import { useQpmCalculationCreateFromOldMutation } from "@/services/backend/qpm/calculations/api/calculation-api";
import { useProcessesProcessShowQuery } from "@/services/backend/processes/api/process-api";
import { Copy } from "lucide-react";
import { v4 } from "uuid";
import { useEffect } from "react";
import t from "@/lang/lang";
import { useToast } from "@/shared/hooks/use-toast";
import { parseRTKQueryError } from "@/shared/components/errors/parse-r-t-k-query-error";
import { Button } from "@/shared/components/ui/button";

interface Props {
  calculationId: string;
  processId: string;
  onCopy: (calculationId: string) => void;
}

export function CopyCalculationButton({
  calculationId,
  processId,
  onCopy,
}: Props) {
  const [copy, { isLoading, error, reset }] =
    useQpmCalculationCreateFromOldMutation();
  const { data: process } = useProcessesProcessShowQuery({ id: processId });
  const { toast } = useToast();

  useEffect(() => {
    if (error) {
      toast({
        ...parseRTKQueryError(error, false),
        variant: "destructive",
      });
      reset();
    }
  }, [error, toast, reset]);

  const onClick = () => {
    if (isLoading) {
      return;
    }

    const id = v4();
    copy({
      oldCalculationId: calculationId,
      newCalculationId: id,
      newProcessId: processId,
      companyId: process?.companyId ?? "",
      branchId: process?.branches[0] ?? "",
    })
      .unwrap()
      .then(() => onCopy(id));
  };

  return (
    <Button onClick={onClick} size="sm">
      <Copy className="mr-2 h-4 w-4" />
      <span>{t("Daten übernehmen")}</span>
    </Button>
  );
}
